export default "__VITE_ASSET__97309697__"